import ServiceCalibMap from 'pages/Robot/RobotView/RobotLeftBlock/Service/ServiceCalibMap'
import { useMemo } from 'react'
import { IMaintenancePoint } from 'utils/interfaces'

import { maintenancePointsToCatalogItems, parseMaintenancePointKey } from 'pages/Assets/maintenance/maintenancePointUtils'

const MaintenancePointsOnMap = ({
  map,
  points,
  highlightedPointId,
  onPointClicked,
  interactive = true,
}: {
  map: mapboxgl.Map | undefined
  points: IMaintenancePoint[]
  highlightedPointId?: number
  onPointClicked?: (id?: number) => void
  interactive?: boolean
}) => {
  const items = useMemo(() => maintenancePointsToCatalogItems(points), [points])
  const selectedKey = highlightedPointId != null ? `mp-${highlightedPointId}` : null

  if (items.length === 0) {
    return null
  }

  return (
    <ServiceCalibMap
      map={map}
      items={items}
      selectedKey={selectedKey}
      onSelectKey={
        interactive
          ? key => {
              onPointClicked?.(parseMaintenancePointKey(key))
            }
          : () => {}
      }
    />
  )
}

export default MaintenancePointsOnMap
